export const REGULAR = 'Regular';
export const GIFT_PLAN = 'Gift Plan';
export const LEG_LEFT = 'Left';
export const LEG_RIGHT = 'Right';